import { ChevronDownIcon } from "lucide-react";
import { Accordion } from "radix-ui";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

export const AccordionTrigger = ({
  className,
  children,
  ...props
}: ComponentProps<typeof Accordion.Trigger>) => (
  <Accordion.Header className="flex">
    <Accordion.Trigger
      data-slot="accordion-trigger"
      className={cn(
        "flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:ring-2 focus-visible:ring-accent/60 disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180",
        className,
      )}
      {...props}
    >
      {children}
      <ChevronDownIcon
        aria-hidden="true"
        className="pointer-events-none size-4 shrink-0 translate-y-0.5 text-muted transition-transform duration-200"
      />
    </Accordion.Trigger>
  </Accordion.Header>
);
